module.exports = __webpack_public_path__ + "static/media/rights_glance.2876e566.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/rights_glance.jpg
// module id = 212
// module chunks = 0